import {Controller} from "stimulus"

// Connects to data-controller="auto-calculate"
export default class extends Controller {
    connect() {
    }

    calculate() {
        let result = document.getElementById(this.element.dataset.result)
        let formula = result.dataset.formula;
        let operands = formula.split(/[+-\/*()]/)
        let eval_str = formula
        operands.forEach(operand => {
            if(operand.trim() !== '') {
                eval_str = eval_str.replace(operand.trim(), document.getElementById(operand.trim()).value || 0)
            }
        })
        result.value = eval(eval_str)
        result.dispatchEvent(new Event("change"))
    }

}
